import { ajax } from "@/plugins/api";
import { users } from "../pages/users/api";
import { tickets } from "../pages/tickets/api";
import { reason } from "../pages/reason/api";
import { departments } from "../pages/departments/api";
import { reviews } from "../pages/reviews/api";
import { promotion } from "../pages/promotion/api";
import { payments } from "../pages/payouts/api";
import { quotes } from "../pages/quotes/api";
import { helper } from "../pages/helper/api";

export const api = {
    users,
    tickets,
    reason,
    departments,
    reviews,
    promotion,
    payments,
    quotes,
    helper,
    agents: {
        all: departmentId => ajax.get("admin/support/agents", { support_department_id: departmentId })
    }
};
